import Vue from 'vue'
import Router from 'vue-router'
import VueWeChatTitle from 'vue-wechat-title'
import {
  decrypt
} from "./utils/utils";
import LoginLayout from './views/LoginLayout.vue'
import Login from './views/Login/Login.vue'
import Home from './views/Home/Home.vue'
import Main from './views/Layout.vue'
import BiddingList from './views/TenderInfo/BiddingList.vue'
import BiddedList from './views/TenderInfo/BiddedList.vue'
import NoBidList from './views/TenderInfo/NoBidList.vue'
import TenderDetail from './views/TenderInfo/TenderDetail.vue'
import ChangePassword from './views/ChangePassword/ChangePassword.vue'
import ForgetPassword from './views/ChangePassword/ForgetPassword.vue'
//import MCP from './views/Home/companyProfile.vue'

Vue.use(Router);
Vue.use(VueWeChatTitle);


const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    component: LoginLayout,
    children: [{
      path: 'login',
      name: 'login',
      meta: {
        title: 'login_pageText.LOGIN'
      },
      component: Login,
    }, {
      path: "forgetpassword",
      name: "forgetpassword",
      meta: {
        title: 'login_pageText.FORGOTPASS',
      },
      component: ForgetPassword,
    }]
  }, {
    path: '/',
    component: Main,
    children: [{
        path: '',
        redirect: 'biddinglist',
      },
      //  {
      //   path: 'home',
      //   name: 'home',
      //   meta: {
      //     title: 'common_pageText.WEBAPPNAME',
      //     keepAlive: false
      //   },
      //   component: Home
      // },
      {
        path: 'tenders',
        name: 'tenders',
        meta: {
          title: 'common_pageText.WEBAPPNAME',
          keepAlive: true
        },
        component: BiddingList
       },
       //{
      //   path: 'mycompanyprofile',
      //   name: 'mycompanyprofile',
      //   meta: {
      //     title: 'common_pageText.WEBAPPNAME',
      //     keepAlive: false
      //   },
      //   component: MCP
      // }
      // , {
      //   path: 'biddedlist',
      //   name: 'biddedlist',
      //   meta: {
      //     title: 'common_pageText.WEBAPPNAME',
      //     keepAlive: false
      //   },
      //   component: BiddedList
      // }, {
      //   path: 'nobidlist',
      //   name: 'nobidlist',
      //   meta: {
      //     title: 'common_pageText.WEBAPPNAME',
      //     keepAlive: false
      //   },
      //   component: NoBidList
      // }
      {
        path: "tenderdetail/:id/:totalcount/:status/:str",
        name: 'tenderdetail',
        meta: {
          title: 'common_pageText.WEBAPPNAME',
          keepAlive: false
        },
        component: TenderDetail,
        props: true
      }, {
        path: "tenderdetail/:id/:totalcount/:status",
        name: 'tenderdetail_1',
        meta: {
          title: 'common_pageText.WEBAPPNAME',
          keepAlive: false
        },
        component: TenderDetail,
        props: true
      }, {
        path: "tenderdetail/:id/:suppliername/:status/:siteid/:rfqnum",
        name: 'tenderdetail_2',
        meta: {
          title: 'common_pageText.WEBAPPNAME',
          keepAlive: false
        },
        component: TenderDetail,
        props: true
      }, {
        path: "changepassword",
        name: "changepassword",
        meta: {
          title: 'common_pageText.WEBAPPNAME',
          keepAlive: false
        },
        component: ChangePassword,
        props: true
      },
    ]
  }]
})

router.beforeEach((to, from, next) => {
  let issupplier = router.app.$cookies.get("issupplier");
  if (to.path != '/login' && to.path != '/forgetpassword') {
    if (!router.app.$cookies.get("id")) {
      next('/login');
    } else {
      let emailverified = decrypt(router.app.$cookies.get("emailverified"));
      
      if (!emailverified) {
        emailverified = '0';
      }
      if (!parseInt(emailverified)) {
        if(to.path != '/changepassword')
          next('/changepassword');
        else next();
      }else{
        if(to.path == '/changepassword' && issupplier=='true'){
            next();
          }else if (to.path == '/changepassword' && issupplier=='false') {
            next('/tenders');
          }else if (to.path == '/') {
            next('/tenders');
          }else {
            if (to.matched.length === 0) { //如果未匹配到路由
              from.path ? next({
                path: from.path
              }) : next('/'); //如果上级也未匹配到路由则跳转主页面，如果上级能匹配到则转上级路由
            } else next();
        }
      }
    }
  } else {
    if (to.matched.length === 0) { //如果未匹配到路由
      from.path ? next({
        path: from.path
      }) : next('/'); //如果上级也未匹配到路由则跳转主页面，如果上级能匹配到则转上级路由
    } else next();
  }
  if(from.name=='tenders' && (to.name=='tenderdetail' || to.name=='tenderdetail_1' || to.name=='tenderdetail_2')){
    //console.log('1111');
    if(!from.meta.keepAlive){
      from.meta.keepAlive = true;
      next();
    }
  }else{
      from.meta.keepAlive = false;
      //to.meta.keepAlive = false;
      next();
  }
  //if(to.path == '/changepassword' && issupplier=='true')next('/changepassword');
  if(router.app.$cookies.get("id") && to.path == '/login')next('/');
  // if(from.name=='biddinglist' && to.name!='tenderdetail' && to.name!='tenderdetail_1' && to.name!='tenderdetail_2'){
  //   from.meta.keepAlive = false;
  //   to.meta.keepAlive = false;
  //   next();
  // }
  // console.log("from.path:"+from.path+'----'+"to.path:"+to.path);
  // console.log('---------------');
})

export default router